import {CompanySettlement1} from "../CompanySettlement/CompanySettlement";

export const CompanySettlements = ({settlements, bullstat}) => {
    return (<table className="table">
        <thead>
        <tr>
            <th scope="col">EKATTE</th>
            <th scope="col">Селище</th>
            <th scope="col">Община</th>
            <th scope="col">Област</th>
            <th scope="col">Декларирана</th>
            <th scope="col">Годна</th>
            <th scope="col">БП</th>
            <th scope="col">Пътища</th>
            <th scope="col">ДЗ</th>
            <th scope="col">Правно</th>
            <th scope="col">Изчертано</th>
            <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        {settlements.map(settlement => (
            <CompanySettlement1 key={settlement.id} {...settlement.settlement} bullstat={bullstat}/>))}
        </tbody>
    </table>)
};